
import { Component } from "@angular/core";
import { CustomizerSettingsService } from "../../customizer-settings/customizer-settings.service";
import { ToggleService } from "../../common/sidebar/toggle.service";
import { CommonModule } from "@angular/common";
import { Router, RouterOutlet } from "@angular/router";

import { FooterComponent } from "../../common/footer/footer.component";
import { HeaderComponent } from "../../common/header/header.component";
import { SidebarComponent } from "../../common/sidebar/sidebar.component";
import { ApplicantAdminDashboardComponent } from "../../applicant-admin-dashboard/applicant-admin-dashboard.component";

@Component({
    selector: 'app-applicant-admin-dash-layout',
  standalone: true,
  templateUrl: './applicant-admin-dash-layout.component.html',
  styleUrl: './applicant-admin-dash-layout.component.scss',
  imports: [
    CommonModule,
    SidebarComponent,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ApplicantAdminDashboardComponent,
  ],
})
export class ApplicantAdminDashLayoutComponent {
  isSidebarToggled: boolean = false;
  isToggled: boolean = false;

  constructor(
    public router: Router,
    private toggleService: ToggleService,

    public themeService: CustomizerSettingsService,
  ) {
    this.toggleService.isSidebarToggled$.subscribe((isSidebarToggled) => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {
    const currentUser = JSON.parse(
      sessionStorage.getItem("currentUser") || "{}",
    );
    const userType = currentUser?.userType;

    if (userType === 4 && this.router.url === "/faculty-admin-dashboard") {
      this.router.navigateByUrl("/faculty-admin-dashboard/welcome");
    }
  }
}


